var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96774 7.75012C4.9231 7.57709 4.83291 7.41918 4.70655 7.29282C4.58019 7.16646 4.42227 7.07626 4.24924 7.03162L1.18174 6.24062C1.1294 6.22577 1.08334 6.19425 1.05054 6.15085C1.01775 6.10744 1 6.05453 1 6.00012C1 5.94572 1.01775 5.89281 1.05054 5.8494C1.08334 5.806 1.1294 5.77448 1.18174 5.75962L4.24924 4.96812C4.42221 4.92353 4.58008 4.83341 4.70644 4.70714C4.83279 4.58088 4.92302 4.42307 4.96774 4.25012L5.75874 1.18262C5.77344 1.13008 5.80493 1.0838 5.8484 1.05082C5.89187 1.01785 5.94493 1 5.99949 1C6.05405 1 6.10711 1.01785 6.15058 1.05082C6.19405 1.0838 6.22553 1.13008 6.24024 1.18262L7.03074 4.25012C7.07538 4.42316 7.16557 4.58107 7.29193 4.70743C7.41829 4.83379 7.5762 4.92399 7.74924 4.96862L10.8167 5.75912C10.8695 5.77367 10.916 5.80513 10.9492 5.84866C10.9823 5.8922 11.0003 5.94541 11.0003 6.00012C11.0003 6.05484 10.9823 6.10805 10.9492 6.15159C10.916 6.19512 10.8695 6.22657 10.8167 6.24112L7.74924 7.03162C7.5762 7.07626 7.41829 7.16646 7.29193 7.29282C7.16557 7.41918 7.07538 7.57709 7.03074 7.75012L6.23974 10.8176C6.22503 10.8702 6.19355 10.9165 6.15008 10.9494C6.10661 10.9824 6.05355 11.0002 5.99899 11.0002C5.94443 11.0002 5.89137 10.9824 5.8479 10.9494C5.80443 10.9165 5.77294 10.8702 5.75824 10.8176L4.96774 7.75012Z",
    stroke: "#6A7282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5V3.5",
    stroke: "#6A7282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.5H9",
    stroke: "#6A7282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5V9.5",
    stroke: "#6A7282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9H1.5",
    stroke: "#6A7282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/aiIcon.beb632db19bc16c5a0af391bac8f4546.svg";
export { ForwardRef as ReactComponent };